class BlogPredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.form = this.querySelector('form');
        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('#predictive-search');
        this.blogArticlesContainer = document.querySelector('#blog-articles');
        this.searchResultContainer = document.querySelector('#blog-search-result-articles');
        this.clearButton = this.querySelector('.blog__search-input-clear');
        this.searchIcon = this.querySelector('.blog__predictive-search-icon');

        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
            this.toggleClearButton();
        }, 300).bind(this));

        this.input.addEventListener('focus', () => {
            if (this.input.value.trim()) {
                this.open();
            }
        });

        this.input.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                this.onSubmit(event);
            }
        });

        this.form.addEventListener('submit', this.onSubmit.bind(this));
        this.clearButton.addEventListener('click', this.clearSearch.bind(this));
        this.searchIcon.addEventListener('click', this.onSubmit.bind(this));

        document.addEventListener('click', this.handleOutsideClick.bind(this));
    }

    handleOutsideClick(event) {
        if (!this.contains(event.target) && !this.predictiveSearchResults.contains(event.target)) {
            this.close();
        }
    }

    onSubmit(event) {
        event.preventDefault();
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) return;

        this.blogArticlesContainer.style.display = 'none';
        this.searchResultContainer.style.display = 'block';

        this.getSearchResults(searchTerm, 'api-search-articles', this.searchResultContainer);
        this.close(); // Закрываем predictiveSearchResults
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.clearSearch();
            return;
        }

        this.getSearchResults(searchTerm, 'blog-predictive-search', this.predictiveSearchResults);
    }

    getSearchResults(searchTerm, sectionId, container) {
        fetch(`/search/suggest?q=${searchTerm}&resources[type]=article&section_id=${sectionId}`)
            .then((response) => {
                if (!response.ok) {
                    this.close();
                    throw new Error(response.status);
                }

                return response.text();
            })
            .then((text) => {
                const parsedHTML = new DOMParser().parseFromString(text, 'text/html');
                const resultsMarkup = parsedHTML.querySelector(`#shopify-section-${sectionId}`)?.innerHTML || '';

                container.innerHTML = resultsMarkup;

                if (sectionId === 'blog-predictive-search') {
                    this.open();
                }
            })
            .catch(() => {
                this.close();
            });
    }

    clearSearch() {
        this.input.value = '';
        this.close();
        this.toggleClearButton();

        this.searchResultContainer.style.display = 'none';
        this.blogArticlesContainer.style.display = 'block';
    }

    toggleClearButton() {
        this.clearButton.style.display = this.input.value.trim().length ? 'flex' : 'none';
    }

    open() {
        this.predictiveSearchResults.style.display = 'block';
    }

    close() {
        this.predictiveSearchResults.style.display = 'none';
    }

    debounce(fn, wait) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

customElements.define('blog-predictive-search', BlogPredictiveSearch);
